'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('antd/lib/menu/style/css');

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _menu = require('antd/lib/menu');

var _menu2 = _interopRequireDefault(_menu);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = _menu2.default.Item,
    SubMenu = _menu2.default.SubMenu,
    ItemGroup = _menu2.default.ItemGroup,
    Divider = _menu2.default.Divider;


var IDMenu = function IDMenu(props) {
    var dataTestID = "menu";
    var getDataTestId = function getDataTestId() {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';
        return props.dataTestID || dataTestID + '-' + prefix;
    };

    return _react2.default.createElement(
        _menu2.default,
        (0, _extends3.default)({}, _lodash2.default.omit(props, 'children'), { 'data-testid': getDataTestId() }),
        props.children
    );
};

IDMenu.Item = Item;
IDMenu.SubMenu = SubMenu;
IDMenu.ItemGroup = ItemGroup;
IDMenu.Divider = Divider;
exports.default = IDMenu;